import type React from 'react'
import type { JSX } from 'react'

import { BANNER_DESCRIPTION_WIDTH } from 'vars/index'
import {
  BannerDescriptionAlignItems,
  BannerDescriptionColumnGap,
  BannerDescriptionDirection,
  BannerDescriptionRowGap,
} from './Description.h'
import { BannerDescriptionStyled } from './Description.styled'

export interface IBannerDescriptionProps {
  children: React.ReactNode
  width?: BANNER_DESCRIPTION_WIDTH
  direction?: BannerDescriptionDirection
  alignItems?: BannerDescriptionAlignItems
  columnGap?: BannerDescriptionColumnGap
  rowGap?: BannerDescriptionRowGap
  className?: string
  style?: React.CSSProperties
}

export const BannerDescription = ({
  children,
  width = BANNER_DESCRIPTION_WIDTH.SIZE_10,
  direction = BannerDescriptionDirection.Column,
  alignItems = BannerDescriptionAlignItems.FlexStart,
  columnGap = BannerDescriptionColumnGap.INDENT_0,
  rowGap = BannerDescriptionRowGap.INDENT_0,
  className = '',
  style,
}: IBannerDescriptionProps): JSX.Element => (
  <BannerDescriptionStyled
    width={width}
    direction={direction}
    alignItems={alignItems}
    columnGap={columnGap}
    rowGap={rowGap}
    className={className}
    style={style}
  >
    {children}
  </BannerDescriptionStyled>
)
